// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/search/v1/sort.proto" (package "c1.api.search.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.search.v1.SortOptions
 */
export interface SortOptions {
    /**
     * @generated from protobuf field: string order_by = 1
     */
    orderBy: string;
    /**
     * @generated from protobuf field: bool descending = 2
     */
    descending: boolean;
}
/**
 * @generated from protobuf enum c1.api.search.v1.SortDirection
 */
export enum SortDirection {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    DESC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SortOptions$Type extends MessageType<SortOptions> {
    constructor() {
        super("c1.api.search.v1.SortOptions", [
            { no: 1, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "descending", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SortOptions>): SortOptions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.orderBy = "";
        message.descending = false;
        if (value !== undefined)
            reflectionMergePartial<SortOptions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SortOptions): SortOptions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string order_by */ 1:
                    message.orderBy = reader.string();
                    break;
                case /* bool descending */ 2:
                    message.descending = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SortOptions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string order_by = 1; */
        if (message.orderBy !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.orderBy);
        /* bool descending = 2; */
        if (message.descending !== false)
            writer.tag(2, WireType.Varint).bool(message.descending);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.SortOptions
 */
export const SortOptions = new SortOptions$Type();
